<template>
    <div :id="globalId" class="layout" :class="{ 'snap-container': isHomePage }">
        <div class="header-container">
            <HeaderNav class="snap-item" />
        </div>
        <div class="main-container">
            <main class="main-content">
                <transition name="fade" mode="out-in">
                    <router-view :key="$route.fullPath" />
                </transition>
            </main>
        </div>
        <p class="disclaimer">
            温馨提示:本网站所展示的相关信息并非旨在推介任何私募基金产品，管理人的过往业绩亦不代表未来业绩。</p>

        <Footer class="pc-footer snap-item" />
        <mobile-footer class="mobile-footer snap-item" />
    </div>
</template>

<script>
import HeaderNav from '../components/HeaderNav/HeaderNav.vue'
import Footer from '../components/Footer/Footer.vue'
import MobileFooter from '../components/mobile/Footer.vue'
export default {
    name: 'MainLayout',
    components: {
        HeaderNav, Footer, MobileFooter
    },
    computed: {
        isHomePage() {
            return this.$route.path === '/home';
        },
        globalId() {
            return 'global';
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            const header = document.querySelector('.header-container');
            if (window.scrollY > 0) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        }
    }
}
</script>

<style lang="less">
.layout {
    width: 100%;
    // overflow: hidden;
    background-color: var(--color-background);
    margin: 0 auto;
    min-width: 375px;
}

.header-container {
    max-width: var(--layout-max-width);
    min-width: var(--layout-min-width);
    margin: 0 auto;
    padding: 0 15rem;
}

.main-container {
    width: 100%;
    min-height: calc(100vh - 400px - 92px);
    /* overflow: hidden;*/
}



.disclaimer {
    text-align: center;
    padding:1rem 1rem 2rem;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.25s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

/* 小屏幕（移动端） */
@media screen and (max-width: 767px) {
    .header-container {
        min-width: auto;
        padding: 0 1rem;

    }

    .main-container {
        min-height: calc(100vh - 46px - 170px);
    }


    .pc-footer {
        display: none;
    }
}

@media screen and (min-width: 768px) {
    .header-container {
        z-index: 2005;
        width: 100%;
        background-color: var(--color-background);
        position: fixed;

        &.scrolled {
            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
        }
    }

    .main-container {
        padding-top: 69px;
    }


    .header-nav-mobile {
        display: none;
    }

    .mobile-footer {
        display: none;
    }
}
</style>